import React, { useState } from "react";
import { Container, Card, Button } from "react-bootstrap";
import { CheckCircleFill, XCircleFill } from "react-bootstrap-icons";
import "bootstrap/dist/css/bootstrap.min.css";

const OrderCancellation = () => {
  const query = new URLSearchParams(window.location.search);
  const paymentType = query.get("type");
  const redirectUrl = query.get("redirect");
  const isApp = query.get("app");

  const [descriptionType, setDescriptionType] = useState(
    paymentType === "LIVE_EVENTS"
      ? "live conference"
      : paymentType === "REFERRAL"
        ? "patient referral profile"
        : paymentType === "PATIENT_REGISTRY"
          ? "patient progress report"
          : "", // default fallback if no match
  );

  if (!paymentType || !redirectUrl || !isApp) {
    return (
      <div className="loader-container">
        <h4>Un Authorized User</h4>
        <button className="orange-btn" onClick={redirectBack}>
          Go to Site
        </button>
      </div>
    );
  }

  const redirectBack = () => {
    window.location.href = `${process.env.REACT_APP_SITE_URL}`;
  };

  const goToApp = () => {
    window.location.href = `${redirectUrl}`;
  };

  return (
    <div style={{ backgroundColor: "#0D2C54", minHeight: "100vh" }}>
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <Card
          className="shadow p-5 text-center"
          style={{ maxWidth: 500, width: "100%", borderRadius: "10px" }}
        >
          <div className="d-flex justify-content-center mb-3">
            <XCircleFill color="#dc3545" size={60} />
          </div>

          <h3 className="fw-bold text-danger">Payment Cancelled</h3>

          <p className="text-muted mt-3 mb-1">
            {`Your payment for the ${descriptionType} was not completed.`}
          </p>

          <p className="text-muted mb-4">
            If this was unintentional, you can try again. No amount has been
            deducted.
          </p>

          <p className="text-muted">
            Attempt Date: {new Date().toLocaleDateString()}
          </p>

          <div className="d-flex gap-2 justify-content-center mt-3">
            <Button
              variant="outline-secondary"
              className="px-4 py-2"
              onClick={goToApp}
            >
              Back to App
            </Button>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default OrderCancellation;
